import clsx from 'clsx';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { Icon } from 'src/components';
import { ThumbnailImage } from '../ThumbnailImage';
import { VideoOverlay } from './styles';
import { ThumbnailVideoProps } from './types';

const ThumbnailVideo = ({ src, dataTestId, className }: ThumbnailVideoProps) => {
  return (
    <div
      className={clsx(
        '_d-flex _justify-content-center _align-items-center _position-relative',
        className
      )}
    >
      <ThumbnailImage src={src} dataTestId={dataTestId} />

      <VideoOverlay className="_d-flex _justify-content-center _align-items-center _position-absolute _rounded">
        <Icon icon={faPlay} className="_text-white" />
      </VideoOverlay>
    </div>
  );
};

export default ThumbnailVideo;
